module.exports = __webpack_public_path__ + "static/media/599.756(8).8ac6b910.pdf";